import React from 'react';
import { Container, Card, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { MarkdownView } from '../components/MarkdownRenderer';
import SEO from '../components/SEO';

const TermsOfService = () => {
  const navigate = useNavigate();

  return (
    <div style={{ 
      minHeight: 'calc(100vh - 120px)', 
      backgroundColor: 'var(--bg-color)',
      color: 'var(--text-color)',
      transition: 'background-color 0.3s ease, color 0.3s ease',
      padding: '20px 0'
    }}>
      <SEO
        title="Terms of Service - Osailu"
        description="Read Osailu's Terms of Service to understand the terms and conditions for using our automation software for virtual learning environments."
        keywords="Osailu terms of service, terms and conditions, user agreement, legal terms"
        url="/terms"
      />
      <Container className="mt-4 mb-5">
      <div className="d-flex justify-content-between align-items-center mb-4">
        {/* Title is inside the markdown document */}
        <Button variant="outline-secondary" onClick={() => navigate(-1)}>
          ← Back
        </Button>
      </div>

      <Card>
        <Card.Body>
          <div className="mb-4">
            <p className="text-muted">
              <strong>Last updated:</strong> {new Date().toLocaleDateString()}
            </p>
          </div>

          <div className="page-content">
            <MarkdownView path="/TERMS_OF_USE.md" />
          </div>
        </Card.Body>
      </Card>
    </Container>
    </div>
  );
};

export default TermsOfService;
